import { Modal } from 'antd';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useList } from '@refinedev/core';
import { DisclaimerContext } from '@/utils/context/disclaimer/Disclaimercontext';

const AlphaDisclaimer = () => {
  const router = useRouter();
  const { accounts } = useMsal();
  const { data: tenantsData, isLoading } = useList({ resource: 'Tenants' });
  const tenantId = tenantsData?.data[0]?.id;
  const { isDisclaimerVisible, setIsDisclaimerVisible } = useContext(DisclaimerContext);

  const handleAgree = () => {
    setIsDisclaimerVisible(false);
    router.push('/company/create');
  };

  useEffect(() => {
    const isNewUser = localStorage.getItem('TENANT_ID');
    if (accounts.length > 0 && isNewUser === 'undefined' && !tenantId) {
      setIsDisclaimerVisible(true);
    }
  }, [accounts, tenantsData, isLoading]);

  return (
    <Modal
      closeIcon={false}
      open={isDisclaimerVisible}
      footer={
        <button
          className="agreeButton hover:bg-primary-light rounded bg-primary px-4 py-2 font-bold text-white"
          onClick={handleAgree}
        >
          Agree
        </button>
      }
    >
      <div>
        <img src="/logos/GrowData-logo-h.png" alt="Growdata logo" />

        <p className="text-justify text-lg">
          This application is currently in alpha release and is provided free of charge for evaluation purposes only.
          Please note that the application will transition to a paid model in the future. Additionally, data may be
          deleted at any given time until the final release, as this is an alpha version.
        </p>
      </div>
    </Modal>
  );
};

export default AlphaDisclaimer;
